import type { UseCase } from '@/core/shared'
import type { UserRepository } from '@/core/user'

export const getAllInvitations: UseCase<UserRepository, 'getAllInvitations'> = repository => {
  return async (organizationUid) => {
    return await repository.getAllInvitations(organizationUid)
  }
}
